import { dia, ui, util, layout } from '@joint/plus';
import { DirectedGraph } from '@joint/layout-directed-graph';
import './shapes';
import { Child, Container, Link } from './shapes';
var cellNamespace = {
    app: {
        Container: Container,
        Child: Child,
        Link: Link
    }
};
export var init = function () {
    var canvas = document.getElementById('canvas');
    var graph = new dia.Graph({}, { cellNamespace: cellNamespace });
    var paper = new dia.Paper({
        model: graph,
        width: 1,
        height: 1,
        gridSize: 10,
        interactive: false,
        async: true,
        frozen: true,
        background: { color: '#F3F7F6' }
    });
    var scroller = new ui.PaperScroller({
        paper: paper,
        cursor: 'grab',
        padding: 0,
        contentOptions: {
            allowNewOrigin: 'any',
            useModelGeometry: true,
            padding: 1000
        }
    });
    canvas.appendChild(scroller.el);
    scroller.render().center();
    scroller.lock();
    createCells(structure, graph);
    layoutCells(graph);
    rescale(scroller);
    paper.unfreeze();
    // register events
    window.addEventListener('resize', util.debounce(function () { return rescale(scroller); }), false);
    paper.on('element:pointermove', function (view, evt, x, y) {
        var model = view.model;
        if (!model.isEmbedded()) {
            return;
        }
        var data = evt.data;
        var ghost = data.ghost;
        if (!ghost) {
            var position = model.position();
            ghost = view.vel.clone();
            ghost.node.style.transition = '0.2s opacity';
            ghost.appendTo(paper.getLayerView(dia.Paper.Layers.FRONT).el);
            evt.data.ghost = ghost;
            evt.data.dx = x - position.x;
            evt.data.dy = y - position.y;
        }
        ghost.attr('opacity', findContainerFromPoint(paper.model, x, y) ? 0.9 : 0.2);
        ghost.attr('transform', "translate(".concat([x - data.dx, y - data.dy], ")"));
    });
    paper.on('element:pointerup', function (view, evt, x, y) {
        var data = evt.data;
        if (!data.ghost) {
            return;
        }
        data.ghost.remove();
        var model = view.model;
        var paperModel = paper.model;
        var newParent = findContainerFromPoint(paperModel, x, y);
        if (!newParent) {
            return;
        }
        var parent = model.getParentCell();
        paper.freeze();
        if (parent) {
            parent.unembed(model);
        }
        newParent.embed(model);
        model.attr(['body', 'fill'], newParent.get('childFill'));
        layoutCells(paperModel);
        paper.unfreeze();
        rescale(scroller);
    });
};
var rescale = function (scroller) {
    scroller.zoomToFit({ padding: 50, useModelGeometry: true });
};
var structure = {
    label: 'a1',
    parentFill: '#202E66',
    childFill: '#2C408F',
    children: [{
            label: 'b1',
            embeds: ['e1', 'e2', 'e3'],
            parentFill: '#334AA6',
            childFill: '#3F5BCC',
            children: [{
                    parentFill: '#4767E6',
                    childFill: '#4B6DF2',
                    label: 'c1',
                    embeds: ['d1', 'd2', 'd3']
                }, {
                    parentFill: '#4767E6',
                    childFill: '#4B6DF2',
                    label: 'c2',
                    embeds: ['d4', 'd5', 'd6']
                }]
        }, {
            label: 'b2',
            parentFill: '#334AA6',
            childFill: '#3F5BCC',
            children: [{
                    parentFill: '#4767E6',
                    childFill: '#4B6DF2',
                    label: 'c3',
                    embeds: ['d7', 'd8', 'd9', 'd10', 'd11']
                }]
        }]
};
var findContainerFromPoint = function (graph, x, y) {
    var modelsFromPoint = graph.findElementsAtPoint({ x: x, y: y });
    return modelsFromPoint.filter(Container.isContainer)[0];
};
var createCells = function (struct, graph) {
    var label = struct.label;
    var children = struct.children || [];
    var embeds = struct.embeds || [];
    var root = new Container({
        attrs: {
            label: {
                text: label
            },
            body: {
                fill: struct.parentFill
            }
        },
        childFill: struct.childFill
    });
    root.addTo(graph);
    if (embeds.length > 0) {
        embeds.forEach(function (text) {
            var embed = new Child({
                attrs: {
                    label: {
                        text: text
                    },
                    body: {
                        fill: struct.childFill
                    }
                }
            });
            embed.resize(50, 50);
            embed.addTo(graph);
            root.embed(embed);
        });
    }
    else {
        root.resize(60, 60);
    }
    if (children.length > 0) {
        children.forEach(function (childStruct) {
            var child = createCells(childStruct, graph);
            var link = new Link();
            link.source(root, { anchor: { name: 'bottom', args: { dy: -20 } } });
            link.target(child, { anchor: { name: 'top' } });
            link.addTo(graph);
        });
    }
    return root;
};
var gridPathData = function (metrics, offset, padding) {
    var bbox = metrics.bbox;
    var x = bbox.x + offset.left;
    var y = bbox.y + offset.top;
    var w = bbox.width;
    var h = bbox.height;
    // Boundary of embedded cells
    var data = [
        'M',
        x - padding, y - padding,
        x + w + padding, y - padding,
        x + w + padding, y + h + padding,
        x - padding, y + h + padding,
        'Z'
    ];
    metrics.gridX.forEach(function (gx, index, gridX) {
        // Skip the first and last line
        if (index === 0 || index === gridX.length - 1) {
            return;
        }
        data.push('M', gx + x, y - padding, gx + x, y + h + padding);
    });
    metrics.gridY.forEach(function (gy, index, gridY) {
        // Skip the first and last line
        if (index === 0 || index === gridY.length - 1) {
            return;
        }
        data.push('M', x - padding, gy + y, x + w + padding, gy + y);
    });
    return data.join(' ');
};
var layoutCells = function (graph) {
    var directedGraphCells = graph.getLinks();
    graph.getElements().forEach(function (container) {
        if (!Container.isContainer(container)) {
            return;
        }
        directedGraphCells.push(container);
        var embeds = container.getEmbeddedCells();
        var embedsCount = embeds.length;
        if (embedsCount === 0) {
            container.attr(['grid', 'd'], 'M 5 35 45 35');
            container.resize(50, 50);
            return;
        }
        var padding = { horizontal: 10, bottom: 10, top: 40 };
        var metrics = layout.GridLayout.layout(embeds, {
            columns: Math.ceil(embedsCount / 2),
            columnGap: 10,
            rowGap: 10
        });
        container.fitEmbeds({ padding: padding });
        container.attr(['grid', 'd'], gridPathData(metrics, util.normalizeSides(padding), 5));
    });
    DirectedGraph.layout(directedGraphCells, {
        setPosition: function (el, center) {
            var size = el.size();
            el.position(center.x - size.width / 2, center.y - size.height / 2, { deep: true });
        }
    });
};
